import { InputSignal } from '@angular/core';

export enum HelpTextPosition {
    ABOVE = 'above',
    BELOW = 'below'
}

export interface HelpText {
    helpText: InputSignal<string>;
    helpTextPosition: InputSignal<HelpTextPosition>;
}
